import React from 'react';
import PropTypes from 'prop-types';
import * as consts from '../../../const';
class QlikReportsTypeComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      radioBtn: 0
    };

    this.onRadioSelect = this.onRadioSelect.bind(this);
  }

  onRadioSelect = (index) => {
    this.setState(() => ({ radioBtn: index }));
    this.props.changeReport(index);
  };

  render() {
    const reportsSheets = this.props.sheets;
    return (
      <form>
        <div className="reports-sheets">
          <h4>{consts.REPORTS_SHEETS_TITLE}</h4>
          <ul>
            {reportsSheets.map((value, index) => {
              return (
                <li key={index} className="radio-btn">
                  <label>
                    <input
                      type="radio"
                      checked={this.state.radioBtn === index}
                      value={value.name}
                      onChange={() => this.onRadioSelect(index)}
                    />
                    {value.name}
                    {value.description && <p>{value.description}</p>}
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
      </form>
    );
  }
}

QlikReportsTypeComponent.propTypes = {
  sheets: PropTypes.any.isRequired,
  changeReport: PropTypes.func.isRequired
};
export default QlikReportsTypeComponent;
